// extracted by mini-css-extract-plugin
module.exports = {"root":"modal_root__314-P","modal":"modal_modal__1DSmH","close":"modal_close__1RNmD"};